import { Injectable } from '@angular/core';

@Injectable()
export class HabilitationCLGuard {

  constructor() { }

  canActivate(): boolean {
    return true;
    // remove comments to return true
    // this._router.navigate(["error"], { queryParams: { unauthorized: true } });
    // return false;
  }

}
